import { getUrlWithSchema } from "@shared/common/utils/url";

export const getNormalizedSixshopProHomeUrl = (siteUrl: string): string => {
  if (!siteUrl) {
    return "";
  }

  try {
    const url = new URL(getUrlWithSchema(siteUrl));

    url.pathname = url.pathname
      .split("/")
      .slice(
        0,
        siteUrl.includes("sixshop3.site") || siteUrl.includes("sixshop.site")
          ? 2
          : 1
      )
      .join("/");

    return getUrlWithSchema(url.href);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return "";
};
